<template>
  <div class="bg-white shadow-md rounded-lg mb-6 p-4">
    <div class="flex justify-between items-start gap-4">
      <div>
        <h3 class="font-semibold">{{ $t('smm.pinterest.title') }}</h3>
        <p v-if="!status?.configured" class="text-sm text-amber-700 mt-1">
          {{ $t('smm.pinterest.env_missing') }}
        </p>
        <p v-else-if="status?.connected" class="text-sm text-green-700 mt-1">
          {{ connectedLabel }}
        </p>
        <p v-else class="text-sm text-gray-500 mt-1">{{ $t('smm.pinterest.not_connected') }}</p>
      </div>
      <div class="flex gap-2 shrink-0">
        <button
          v-if="status?.connected"
          @click="disconnect"
          class="text-sm text-gray-600 hover:text-red-600 px-2 py-1"
        >
          {{ $t('smm.pinterest.disconnect') }}
        </button>
        <button
          v-if="status?.configured && !status?.connected"
          @click="connect"
          :disabled="connecting"
          class="text-sm bg-red-600 hover:bg-red-700 text-white px-3 py-1.5 rounded-lg disabled:opacity-50"
        >
          {{ connecting ? $t('common.loading_short') : $t('smm.pinterest.connect') }}
        </button>
      </div>
    </div>

    <div v-if="status?.connected" class="mt-4 space-y-3">
      <div>
        <label class="text-sm text-gray-600">{{ $t('smm.pinterest.default_board') }}</label>
        <div class="flex gap-2 mt-1">
          <select v-model="defaultBoardId" class="flex-1 border rounded-lg p-2 text-sm">
            <option value="">{{ $t('smm.pinterest.select_board') }}</option>
            <option v-for="b in boards" :key="b.id" :value="b.id">{{ b.name }}</option>
          </select>
          <button
            @click="saveBoard"
            :disabled="!defaultBoardId || savingBoard"
            class="text-sm bg-blue-600 text-white px-3 py-2 rounded-lg disabled:opacity-50"
          >
            {{ savingBoard ? $t('common.saving') : $t('common.save') }}
          </button>
        </div>
      </div>
      <p class="text-xs text-gray-400">
        {{ $t('smm.pinterest.redirect_uri', { uri: redirectHint }) }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    networkId: { type: [Number, String], required: true },
  },
  data: () => ({
    status: null,
    boards: [],
    defaultBoardId: '',
    connecting: false,
    savingBoard: false,
    redirectHint: `${window.location.protocol}//vue-laravel-spa.test/smm/pinterest/callback`,
  }),
  computed: {
    connectedLabel() {
      const username = this.status?.provider_username
      if (username) {
        return this.$t('smm.pinterest.connected', { username })
      }
      return this.$t('smm.pinterest.connected', { username: '' }).replace(/:\s*@?\s*$/, '')
    },
  },
  mounted() {
    this.loadStatus()
    this.checkQuery()
  },
  methods: {
    base() {
      return `/api/v1/smm/social-networks/${this.networkId}/pinterest`
    },
    async loadStatus() {
      try {
        const { data } = await axios.get(`${this.base()}/status`)
        this.status = data.data
        this.defaultBoardId = data.data.default_board_id || ''
        if (data.data.connected) {
          await this.loadBoards()
        }
      } catch (e) {
        console.error(e)
      }
    },
    async loadBoards() {
      const { data } = await axios.get(`${this.base()}/boards`)
      this.boards = data.data
    },
    async connect() {
      this.connecting = true
      try {
        const { data } = await axios.post(`${this.base()}/connect`)
        window.location.href = data.data.authorization_url
      } catch (e) {
        alert(e.response?.data?.message || this.$t('smm.pinterest.connect_error'))
        this.connecting = false
      }
    },
    async disconnect() {
      if (!confirm(this.$t('smm.pinterest.disconnect_confirm'))) return
      await axios.delete(`${this.base()}/disconnect`)
      await this.loadStatus()
    },
    async saveBoard() {
      this.savingBoard = true
      try {
        await axios.put(`${this.base()}/settings`, { default_board_id: this.defaultBoardId })
        alert(this.$t('smm.pinterest.board_saved'))
      } catch (e) {
        alert(e.response?.data?.message || this.$t('common.error'))
      } finally {
        this.savingBoard = false
      }
    },
    checkQuery() {
      const q = this.$route.query
      if (q.pinterest === 'connected') {
        alert(this.$t('smm.pinterest.connected_success'))
        this.$router.replace({ query: {} })
        this.loadStatus()
      }
      if (q.pinterest_error) {
        alert(decodeURIComponent(q.pinterest_error))
        this.$router.replace({ query: {} })
      }
    },
  },
}
</script>
